import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemListForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemListForCatalogController.php
* @route '/api/item-catalog'
*/
const GetItemListForCatalogController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForCatalogController.url(options),
    method: 'get',
})

GetItemListForCatalogController.definition = {
    methods: ["get","head"],
    url: '/api/item-catalog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemListForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemListForCatalogController.php
* @route '/api/item-catalog'
*/
GetItemListForCatalogController.url = (options?: RouteQueryOptions) => {
    return GetItemListForCatalogController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemListForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemListForCatalogController.php
* @route '/api/item-catalog'
*/
GetItemListForCatalogController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForCatalogController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemListForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemListForCatalogController.php
* @route '/api/item-catalog'
*/
GetItemListForCatalogController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemListForCatalogController.url(options),
    method: 'head',
})

export default GetItemListForCatalogController